import { Button } from 'mypages-library';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  getCurrentPasswordErrors,
  getPasswordRequirements,
  isPasswordValid,
  passwordAndRepeatMatch,
} from 'components/Input/passwordValidationUtil';
import PasswordInput from 'components/Input/PasswordInput';
import InputValidation from 'components/Input/InputValidation';
import styles from './ChangePassword.module.scss';
import PageTemplate from './PageTemplate';

export type EnterPasswordProps = {
  changePassword: (password: string) => void;
  isLoading: boolean;
  error: string;
};

const EnterNewPassword = ({ changePassword, isLoading, error }: EnterPasswordProps) => {
  const { t } = useTranslation();
  const [password, setPassword] = useState('');
  const [repeatPassword, setRepeatPassword] = useState('');

  const repeatPasswordError = repeatPassword?.length > 0 && !passwordAndRepeatMatch(password, repeatPassword);
  const repeatPasswordErrorMsg = repeatPasswordError ? t('MPL_PASSWORD_VALIDATION_PASSWORDS_NOT_MATCHING') : '';
  const passwordError = password?.length > 0 && !isPasswordValid(password);
  const disableSubmit =
    repeatPasswordError || passwordError || password.length === 0 || repeatPassword.length === 0 || isLoading;

  const onSubmit = () => {
    changePassword(password);
  };

  return (
    <PageTemplate>
      <h1 className={styles.title}>{t('MPL_CHANGE_PW_TITLE')}</h1>
      <p className={styles.text}>{t('MPL_CHANGE_PW_ENTER_NEW_INSTRUCTION')}</p>
      <InputValidation
        inputToValidate={password}
        requirements={getPasswordRequirements(password)}
        errorList={getCurrentPasswordErrors(password)}
      >
        <PasswordInput
          placeholder={t('MPL_LOGIN_PLACEHOLDER_PASSWORD')}
          onChange={setPassword}
          value={password}
          maxLength={30}
          dataTestId="change-password"
          autoComplete="current-password"
          hasError={passwordError}
        />
      </InputValidation>
      <PasswordInput
        placeholder={t('MPL_LOGIN_PLACEHOLDER_REPEAT_PASSWORD')}
        onChange={setRepeatPassword}
        value={repeatPassword}
        maxLength={30}
        dataTestId="change-password-repeat"
        autoComplete="current-password"
        hasError={repeatPasswordError}
        errorMessage={repeatPasswordErrorMsg}
      />
      {error && <p className={styles.error}>{error}</p>}
      <Button
        text={t('MPL_SAVE')}
        disabled={disableSubmit}
        className={styles.confirmButton}
        white
        onClick={onSubmit}
        dataTestId="submit-new-password"
        isLoading={isLoading}
      />
    </PageTemplate>
  );
};
export default EnterNewPassword;
